import { CaseState } from 'app/area/case/types-store';

export const entityId = (state: CaseState, uiEngineProps: any) => {

  const hostProps = uiEngineProps.hostProps();
    
  return { 
    entityId: hostProps && hostProps.entityId
  };
};
